// Runtime de plugins en el navegador.
// Expone las instancias del host (React, MUI, emotion) como SINGLETONS read-only para que
// los bundles dinamicos de plugins NO empaqueten su propio React (lo que romperia los hooks).
// Los plugins con UI custom se compilan marcando estas libs como externals y las consumen de aqui.
import React from 'react';
import * as ReactDOM from 'react-dom';
import * as MUI from '@mui/material';
import * as MUIStyles from '@mui/material/styles';
import * as Emotion from '@emotion/react';
import { PLUGIN_ICONS } from './pluginIcons';

const GLOBAL_KEY = '__ENIGMA_PLUGINS__';

let initialized = false;

export function initPluginRuntime() {
  if (initialized || typeof window === 'undefined') return window?.[GLOBAL_KEY];

  // Registro de componentes que aportan los bundles dinamicos: { [slug]: { [surfaceId]: Component } }
  const registry = {};

  const runtime = {
    version: 1,
    React,
    ReactDOM,
    MUI,
    MUIStyles,
    MUIIcons: PLUGIN_ICONS,
    Emotion,
    registry,
    // Un bundle de plugin llama a esto para registrar sus componentes por superficie.
    register(slug, components) {
      if (!slug || !components) return;
      registry[slug] = { ...(registry[slug] || {}), ...components };
    },
    getComponent(slug, surfaceId) {
      return registry[slug] ? registry[slug][surfaceId] : undefined;
    }
  };

  // Read-only: un plugin no puede reemplazar React/MUI del host.
  try {
    Object.defineProperty(window, GLOBAL_KEY, { value: Object.freeze(runtime), writable: false, configurable: false });
  } catch (_) {
    window[GLOBAL_KEY] = runtime;
  }
  initialized = true;
  return window[GLOBAL_KEY];
}

export function getPluginRuntime() {
  if (typeof window === 'undefined') return null;
  return window[GLOBAL_KEY] || null;
}

export const PLUGIN_RUNTIME_GLOBAL = GLOBAL_KEY;
